import { api } from '@marketplace-web/core-api/core-api-client-util'

import { SellerBadgesListResp, SellerBadgesResp } from '../types/seller-badge'

export const getSellerBadgesList = (userId: number) =>
  api.get<SellerBadgesListResp>(`/seller_badges_list/${userId}`)

export const getSellerBadges = () => api.get<SellerBadgesResp>('/seller_badges')
